// @ts-nocheck
import { Column } from 'react-table';
import { useIntl } from 'react-intl';
import { PaymentMethod } from '../../core/_models';
import { PaymentMethodCustomHeader } from './PaymentMethodCustomHeader';
import { PaymentMethodActionsCell } from './PaymentMethodActionsCell';

const paymentMethodsColumns: ReadonlyArray<Column<PaymentMethod>> = [
  {
    Header: (props) => (
      <PaymentMethodCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.CODE' })}
        className='min-w-125px'
      />
    ),
    id: 'code',
    Cell: ({ row }) => <span>{row.original.code}</span>,
  },
  {
    Header: (props) => (
      <PaymentMethodCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.DESCRIPTION' })}
        className='min-w-150px'
      />
    ),
    id: 'description',
    Cell: ({ row }) => <span>{row.original.description || '-'}</span>,
  },
  {
    Header: (props) => (
      <PaymentMethodCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.STATUS' })}
        className='min-w-75px'
      />
    ),
    id: 'isActive',
    Cell: ({ row }) => (
      <span className={`badge ${row.original.isActive ? 'badge-light-success' : 'badge-light-danger'}`}>
        {row.original.isActive ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <PaymentMethodCustomHeader tableProps={props} title='' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <PaymentMethodActionsCell id={props.data[props.row.index]._id} />,
  },
];

export { paymentMethodsColumns };
